export enum DepartmentAssignmentHistoryTypeEnum {
  Manual = 0,
  Auto = 1,
  Scheduled = 2
}

export const DEPARTMENT_ASSIGNMENT_HISTORY_TYPE_LABELS: Record<
  DepartmentAssignmentHistoryTypeEnum,
  string
> = {
  [DepartmentAssignmentHistoryTypeEnum.Manual]: 'Вручную',
  [DepartmentAssignmentHistoryTypeEnum.Auto]: 'Автораспределение',
  [DepartmentAssignmentHistoryTypeEnum.Scheduled]: 'По расписанию'
};

export function formatDepartmentAssignmentHistoryType(
  type: number | null | undefined
): string {
  if (type === null || type === undefined || Number.isNaN(Number(type))) {
    return '';
  }
  const n = Number(type);
  const label =
    DEPARTMENT_ASSIGNMENT_HISTORY_TYPE_LABELS[
      n as DepartmentAssignmentHistoryTypeEnum
    ];
  return label ?? String(type);
}

export enum DepartmentAssignmentHistoryErrorEnum {
  TaskStartError = 0,
  TaskFinishError = 1,
  AssetError = 2,
  AssetAddressError = 3,
  TaskNotFound = 4,
  TaskTypeError = 5,
  TaskTypeResolutionTimeError = 6,
  TaskTypeResponseTimeError = 7,
  TaskTypeProcessingTimeError = 8,
  DepartmentNotFound = 9,
  PlanningAlgorithmError = 10
}

export const DEPARTMENT_ASSIGNMENT_HISTORY_ERROR_LABELS: Record<number, string> =
  {
    [DepartmentAssignmentHistoryErrorEnum.TaskStartError]:
      'Ошибка даты начала наряда',
    [DepartmentAssignmentHistoryErrorEnum.TaskFinishError]:
      'Ошибка даты окончания наряда',
    [DepartmentAssignmentHistoryErrorEnum.AssetError]: 'Ошибка объекта',
    [DepartmentAssignmentHistoryErrorEnum.AssetAddressError]:
      'Ошибка адреса объекта',
    [DepartmentAssignmentHistoryErrorEnum.TaskNotFound]: 'Наряд не найден',
    [DepartmentAssignmentHistoryErrorEnum.TaskTypeError]: 'Ошибка типа наряда',
    [DepartmentAssignmentHistoryErrorEnum.TaskTypeResolutionTimeError]:
      'Ошибка времени реакции типа наряда',
    [DepartmentAssignmentHistoryErrorEnum.TaskTypeResponseTimeError]:
      'Ошибка времени отклика типа наряда',
    [DepartmentAssignmentHistoryErrorEnum.TaskTypeProcessingTimeError]:
      'Ошибка времени обработки типа наряда',
    [DepartmentAssignmentHistoryErrorEnum.DepartmentNotFound]:
      'Участок не найден',
    [DepartmentAssignmentHistoryErrorEnum.PlanningAlgorithmError]:
      'В типе наряда не задан алгоритм распределения'
  };

export enum EmployeeAssignmentHistoryErrorEnum {
    EmployeeNotFound = 0,
    NotEnoughEmployees = 1,
    DepartmentWithoutEmployees = 2,
    TaskTypeError = 3,
    TaskZeroEmployeeCount = 4,
    TaskStartError = 5,
    TaskFinishError = 6,
    TaskNotFound = 7,
    PlanningAlgorithmError = 8,
}

export const EMPLOYEE_ASSIGNMENT_HISTORY_ERROR_LABELS: Record<number, string> =
  {
    [EmployeeAssignmentHistoryErrorEnum.EmployeeNotFound]:
      'Не найдено ни одного работника',
    [EmployeeAssignmentHistoryErrorEnum.NotEnoughEmployees]:
      'Найдено меньше работников, чем требуется',
    [EmployeeAssignmentHistoryErrorEnum.DepartmentWithoutEmployees]: 'В участке нет работников',
    [EmployeeAssignmentHistoryErrorEnum.TaskTypeError]:
      'Не указан тип наряда',
    [EmployeeAssignmentHistoryErrorEnum.TaskZeroEmployeeCount]: 'В типе наряда не указано количество работников',
    [EmployeeAssignmentHistoryErrorEnum.TaskStartError]: 'Не указано плановое начало',
    [EmployeeAssignmentHistoryErrorEnum.TaskFinishError]:
      'Не указано плановое завершение',
    [EmployeeAssignmentHistoryErrorEnum.TaskNotFound]:
      'Наряд с таким идентификатором не найден',
    [EmployeeAssignmentHistoryErrorEnum.PlanningAlgorithmError]:
      'В типе наряда не задан алгоритм распределения'
  };

export function formatDepartmentAssignmentErrors(
  codes: number[] | null | undefined,
  assignmentEnums: Record<number, string>
): string {
  if (codes == null) {
    return '';
  }
  // TODO: выпилить после стабилизации API — errors всегда number[] (сейчас иногда приходит не-массив).
  if (!Array.isArray(codes)) {
    return '';
  }
  if (codes.length === 0) {
    return '';
  }
  return codes
    .map((n) => {
      if (assignmentEnums[n]) {
        return assignmentEnums[n];
      }
      return `Неизвестная ошибка (${n})`;
    })
    .join('; ');
}
